<template>
  <div>
    <hr />
    <div class="flex-1 jbet">
      <div></div>

      <div class="f-title">
        <h3 class="text-center text-success font-weight-bold md-3">
          Produtos / Cavidades
          <i class="fas fa-clipboard-check" aria-hidden="true"></i>
        </h3>
      </div>
      <div class="m-20">
        <label class="col-form-label font-weight-bold">
          Nº Total de Cavidades</label>

        <div class="flex-n">
          <input v-model="numeroTotaldeCavid" v-maska="['##', '']" class="form-control p-3" placeholder="" disabled />
          <span class="input-group-text" id="addon-wrapping">Número </span>
        </div>
      </div>
    </div>

    <!-- Card personalizado -->
    <div class="card shadow mb-4">
      <div class="card-body">
        <div class="flex-1" v-show="showMoldePorCavidade">
          <div>
            <label class="col-form-label font-weight-bold">
              Código Produto
            </label>
            <input @change="mapProduct(this.codigoProduto)" list="ProdutsList" v-model="codigoProduto"
              v-maska="['##.###.######.##-##', '']" class="form-control-2 p-3" placeholder="" />
            <div class="text-red" v-if="validationProduct === true">
              Código do Produto não encontrado no Sap..
            </div>
            <datalist id="ProdutsList">
              <div v-for="l in $store.state.emitData.produtos" :key="l.id">
                <option :value="l.cp">
                  {{ l.p }}
                </option>
              </div>
            </datalist>
          </div>

          <div class="m-40">
            <label class="col-form-label font-weight-bold m-40">
              Produto
            </label>
            <input type="text" class="form-control-2 p-3" :placeholder="descproduto" disabled />
          </div>

          <div>
            <label class="col-form-label font-weight-bold">
              Nº Cavidades/Produto
            </label>
            <input v-maska="['##', '']" v-model="nCavidadeProduto" class="form-control-2 p-3" placeholder="Ex: 4" />
          </div>
          <!-- Button add Cavidade / Produto -->
          <div class="button-add">
            <label class="col-form-label"></label>
            <button type="button" @click.prevent="addCavidadeAndProduto"
              class="form-control-2 rounded-circle shadow-sm btn-success">
              <i class="fas fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <!-- Table List de Cavidade / Produtos -->
        <div class="flex-1">
          <div class="tableCavidade">
            <table>
              <thead>
                <tr>
                  <th>Código do Produto</th>
                  <th>Produto</th>
                  <th>Nº Cavidade</th>
                  <td>Opção</td>
                </tr>
              </thead>

              <tbody v-for="(l, index) in dados.lista_ProdutoAndCavidades" :key="l.idp">
                <tr>
                  <td style="display: none"></td>
                  <td data-title="Código  Produto">{{ l.produto.cp }}</td>
                  <td data-title="Produto">{{ l.produto.p }}</td>
                  <td data-title="Nº  Cavidade">{{ l.ncavidade }}</td>
                  <td class="btnDelete">
                    <button v-show="showMoldePorCavidade" @click.prevent="excluir(index)" type="button">
                      Excluir
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- FIM TABLE -->

    <div class="flex">
      <div class="flex-column">
        <div class="justify-content-center">
          <h3 class="text-center text-success font-weight-bold md-3">
            Tipo de Injeção
          </h3>
        </div>

        <div class="modal-body row">
          <div class="jbet card-header shadow col-md-12 d-flex flex-row">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" v-model="dados.tipo_de_injecao.direta" id="direta"
                :value="false" :disabled="configInputs" />
              <label class="custom-control-label font-weight-bold" for="direta">Direta</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" v-model="dados.tipo_de_injecao.indireta" id="indireta"
                :value="false" :disabled="configInputs" />
              <label class="custom-control-label font-weight-bold" for="indireta">Indireta</label>
            </div>
            <!-- <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                v-model="dados.tipo_de_injecao.camera_quente"
                id="cameraquente"
                :value="false"
                :disabled="configInputs"
                
                :checked="checkedCamara"
              />
              <label
                class="custom-control-label font-weight-bold"
                for="cameraquente"
                >
                Câmara Quente
              </label> -->
            <!-- </div> -->
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" v-model="dados.tipo_de_injecao.bico_quente"
                id="bicoquente" :value="false" :disabled="configInputs" />
              <label class="custom-control-label font-weight-bold" for="bicoquente">Bico Quente</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Tipo de Entrda de Injeceção -->
      <!-- <div class="flex-column">
        <div class="flex-row flex gap"> -->
      <!-- Indireta  -->
      <!-- <div v-if="dados.tipo_de_injecao == 'indireta'">
            <div class="justify-content-center">
              <h3 class="text-center text-success font-weight-bold md-3">
                Tipo de Entrada de Injeção
              </h3>
            </div>

            <div class="shadow card-height m-100 card-body-1">
              <div class="flex-row justify-content-center align-items-center">
                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoCircular"
                      value="Circular"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoCircular"
                      >Circular</label
                    >
                  </div>
                </div>

                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoSubmersa"
                      value="Submersa"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoSubmersa"
                      >Submersa</label
                    >
                  </div>
                </div>

                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoCapilar"
                      value="Capilar"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoCapilar"
                      >Capilar</label
                    >
                  </div>
                </div>

                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoLeque"
                      value="Leque"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoLeque"
                      >Leque</label
                    >
                  </div>
                </div>

                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoRestrita"
                      value="Restrita"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoRestrita"
                      >Restrita</label
                    >
                  </div>
                </div>

                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoAba"
                      value="Aba"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoAba"
                      >Aba</label
                    >
                  </div>
                </div>

                <div>
                  <div class="custom-control custom-radio">
                    <input
                      v-model="dados.tipo_de_entrada_de_injecao"
                      type="radio"
                      class="custom-control-input"
                      name="tipoEntradaIndireta"
                      id="entradaInjecaoOutros"
                      value="Outros"
                      :disabled="configInputs"
                    />
                    <label
                      class="custom-control-label font-weight-bold mx-3"
                      for="entradaInjecaoOutros"
                      >Outros</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div> -->

      <!-- Camera Quente -->
      <!-- <div v-if="dados.tipo_de_injecao == 'cameraquente'">
            <div class="justify-content-center">
              <h3 class="text-center text-success font-weight-bold md-3">
                Tipo de Entrada de Injeção
              </h3>
            </div>

            <div
              class="
                flex-row
                justify-content-center
                align-items-center
                shadow
                card-height
                m-100
                card-body-1
              "
            >
              <div>
                <div class="custom-control custom-radio">
                  <input
                    v-model="dados.tipo_de_entrada_de_injecao"
                    type="radio"
                    class="custom-control-input"
                    name="tipoEntradaIndireta"
                    id="entradaInjecaoBico_Valvulado"
                    value="Bico_Valvulado"
                    :disabled="configInputs"
                  />
                  <label
                    class="custom-control-label font-weight-bold mx-3"
                    for="entradaInjecaoBico_Valvulado"
                    >Bico Valvulado</label
                  >
                </div>
              </div>

              <div>
                <div class="custom-control custom-radio">
                  <input
                    v-model="dados.tipo_de_entrada_de_injecao"
                    type="radio"
                    class="custom-control-input"
                    name="tipoEntradaIndireta"
                    id="entradaInjecaoBico_Direto"
                    value="Bico_Direto"
                    :disabled="configInputs"
                  />
                  <label
                    class="custom-control-label font-weight-bold mx-3"
                    for="entradaInjecaoBico_Direto"
                    >Bico Direto</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-red" v-if="v$.dados.tipo_de_injecao.$error">
          Tipo de Injeção é obrigatório.
        </div>
      </div> -->
      <!-- 
      <div class="text-red" v-if="v$.dados.tipo_de_injecao.direta.$error">
        Tipo de Injeção é obrigatório.
      </div>

      <div class="text-red" v-if="v$.dados.tipo_de_injecao.$invalid">
        Tipo de Injeção é obrigatório.
      </div> -->
    </div>

    <!--  Gavetas -->
    <hr />

    <div>
      <div class="form-group col-md-3 mb-3">
        <div class="flex-row flex align-items-flex-start">
          <label class="col-form-label font-weight-bold">O molde possui gavetas ?</label>
          <div class="flex-n gap">
            <div class="inputFlex">
              <input id="simGavetas" name="possuiGavetas" type="radio" v-model="dados.gavetas.selectObject"
                class="custom-control-input" value="true" :disabled="configInputs" />
              <label class="custom-control-label" for="simGavetas"> SIM</label>
            </div>
            <div class="inputFlex">
              <input id="naoGavetas" name="possuiGavetas" type="radio" v-model="dados.gavetas.selectObject"
                class="custom-control-input" :value="false" :disabled="configInputs" />
              <label class="custom-control-label" for="naoGavetas"> NÃO</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="dados.gavetas.selectObject" class="flex-row">
      <!--  Gavetas QTD - Esquerdo -->
      <div class="flex-row align-items-center flex m-100 gap">
        <div>
          <h3 class="text-center text-success font-weight-bold md-3">
            Gavetas QTD
          </h3>
        </div>

        <div>
          <label class="col-form-label font-weight-bold"> Lado Móvel </label>
          <!-- v-maska="['###.##', '##.##', '#.##', '#x#']" -->
          <input v-model="v$.dados.gavetas.lado_movel.$model" class="form-control-2 p-3" placeholder="Não Adicionado"
            :disabled="configInputs" />
          <div class="text-red" v-if="v$.dados.gavetas.lado_movel.$error">
            Opção de Lado Movel requer dados numerico.
          </div>
        </div>

        <div>
          <label class="col-form-label font-weight-bold"> Lado Fixo </label>
          <!-- <div class="flex-n">      -->
          <!-- v-maska="['###.##', '##.##', '#.##', '#x#']" -->
          <input v-model="v$.dados.gavetas.lado_fixo.$model" class="form-control-2 p-3" placeholder="Não Adicionado"
            :disabled="configInputs" />
        </div>
        <!-- <span class="input-group-text" id="addon-wrapping">mm</span>
        </div> -->

        <div class="text-red" v-if="v$.dados.gavetas.lado_fixo.$error">
          Opção de Lado Fixo requer dados numerico.
        </div>
      </div>

      <!-- Gavetas de Acionamento - Direita -->
      <div class="flex-direction-column gap m-100">
        <div>
          <h3 class="text-center text-success font-weight-bold md-3">
            Gavetas de Acionamento
          </h3>
        </div>

        <div class="flex-row flex">
          <div class="custom-control custom-checkbox mr-sm-2">
            <input v-model="dados.gavetas.mecanico" type="checkbox" class="custom-control-input" name="mecanico"
              id="mecanico" :disabled="configInputs" />
            <label class="custom-control-label font-weight-bold mx-3" for="mecanico">Mecânico</label>
          </div>

          <div class="custom-control custom-checkbox mr-sm-2">
            <input v-model="dados.gavetas.pneumatico" type="checkbox" class="custom-control-input" name="pneumatico"
              id="pneumatico" :disabled="configInputs" />
            <label class="custom-control-label font-weight-bold mx-3" for="pneumatico">Pneumático</label>
          </div>

          <div class="custom-control custom-checkbox mr-sm-2">
            <input v-model="dados.gavetas.hidraulico" type="checkbox" class="custom-control-input" name="hidraulico"
              id="hidraulico" :disabled="configInputs" />
            <label class="custom-control-label font-weight-bold mx-3" for="hidraulico">Hidráulico</label>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <hr />
    <!-- Maquinas -->

    <div class="flex-direction-column justify-content-center m-100 gap">
      <div>
        <h3 class="text-center text-success font-weight-bold md-3">
          Escolha de Máquina Injetora
        </h3>
      </div>

      <div class="flex-row gap">
        <div>
          <label class="col-form-label font-weight-bold"> Opção I : </label>
          <input @click="mapMachine" list="MaquinaList" v-model="v$.dados.maquinas.op1.$model" type="text"
            :class="['form-control-2', { error: v$.dados.maquinas.op1.$error }]" placeholder=""
            :disabled="configInputs" />
          <div class="text-red" v-if="v$.dados.tipo_de_injecao.$error">
            O campo Opção 1 é obrigatório.
          </div>
          <div class="text-red" v-if="validationMachine === true">
            Máquina informada não encontrada no Sap.
          </div>
        </div>

        <div>
          <label class="col-form-label font-weight-bold"> Opção II : </label>
          <input @click="mapMachine" list="MaquinaList" v-model="dados.maquinas.op2" type="text"
            class="form-control-2 p-3" placeholder="" :disabled="configInputs" />
        </div>

        <div>
          <label class="col-form-label font-weight-bold"> Opção III : </label>
          <input @click="mapMachine" list="MaquinaList" v-model="dados.maquinas.op3" type="text"
            class="form-control-2 p-3" placeholder="" :disabled="configInputs" />
        </div>
      </div>
      <datalist id="MaquinaList">
        <div v-for="(l, index) in listmaquinas" :key="index">
          <option :value="l.codigoMaquina">
            {{ l.codigoMaquina }}
          </option>
        </div>
      </datalist>
    </div>

    <hr />

    <div class="flex-direction-column align-items-flex-start justify-content-center m-100 gap">
      <div style="width: 100%">
        <label class="col-form-label font-weight-bold">
          Comentários Molde Aberto:
        </label>
        <textarea v-model="dados.observacao_tec" class="form-control-2 p-3" rows="5" cols="50"
          placeholder="Só pode ser usado 500 caracteres..." maxlength="500" :disabled="configInputs"
          style="resize: none">
        </textarea>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { toRaw } from "vue";
import { sap } from "../../../../../../http";

export default {
  props: {
    configInputs: Number,
    Cavity: Number,
    molde: String,
    checkedCamara: Boolean,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  async created() {
    // const produto = await sap.get("/boms");
    // const maquina = await sap.get("/machines");
    // if (res) {

    // }
    // produto.data.results.map((item, index) => {
    //   this.lista_pro.push({
    //     id: index,
    //     cp: item.Code,
    //     p: item.Name,
    //     cmp: 200,
    //     // mp: item.materia,
    //   });
    // });

    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },

  data() {
    return {
      showMoldePorCavidade: true,
      validationProduct: false,
      validationMachine: false,
      lista_oficial: [],
      //  Lista de Produto
      listmaquinas: [],
      lista_pro: [],
      listaProdutos: [],
      cod_product: "",

      numeroTotaldeCavid: Number,
      codigoProduto: "",
      nCavidadeProduto: Number,
      contador: 0,
      BooleanTotalCavidade: false,
      descproduto: "",
      tipoDeInjecaoIndireta: false,
      tipoDeInjecaoCamQuent: false,
      showcameraquente: false,

      dados: {
        lista_ProdutoAndCavidades: [],
        tipo_de_injecao: {
          direta: false,
          indireta: false,
          camera_quente: false,
          bico_quente: false,
        },
        tipo_de_entrada_de_injecao: "",
        gavetas: {
          selectObject: false,
          lado_movel: "",
          lado_fixo: "",
          mecanico: false,
          pneumatico: false,
          hidraulico: false,
        },
        maquinas: {
          op1: "",
          op2: "",
          op3: "",
        },
        observacao_tec: "",
      },
    };
  },
  validations() {
    return {
      dados: {
        maquinas: {
          op1: {
            required,
          },
        },
        tipo_de_injecao: {
          required,
        },
        gavetas: {
          lado_movel: {
            // minValueValue: minValue(1),
            // numeric,
          },
          lado_fixo: {
            // minValueValue: minValue(1),
            // numeric,
          },
        },
      },
    };
  },
  methods: {
    async mapProduct(product) {
      this.$store.commit("SetLoading", true); // insere o loading
      if (product.trim() === "") {
        this.validationProduct = false;
        this.$store.commit("SetLoading", false);
        return;
      }

      // Ok
      const { data: productOne } = await sap.get(`/cod_product`, {
        params: {
          unidade: "MAO",
          cod_product: product,
        },
      }).catch((e) => this.$store.commit("SetLoading", false))

      if (!productOne) {
        this.$store.commit("SetLoading", false);
        this.lista_pro = [];
        this.descproduto = "";
        this.validationProduct = true;
        return;
      }

      this.lista_pro.push({
        id: 1,
        cp: productOne.codigo_produto,
        p: productOne.descricao_produto,
        cmp: 200,
      });

      this.descproduto = productOne.descricao_produto;

      // Sem molde consultado em Informações Gerais, usa a cavidade do molde do produto
      const cavityQty =
        productOne.resource &&
        productOne.resource.mold &&
        productOne.resource.mold.cavityQty;
      if (isNaN(parseInt(this.numeroTotaldeCavid)) && cavityQty) {
        this.numeroTotaldeCavid = cavityQty;
      }
      if (isNaN(parseInt(this.nCavidadeProduto)) && cavityQty) {
        this.nCavidadeProduto = cavityQty;
      }
      this.validationProduct = false;
      this.$store.commit("SetLoading", false);
    },
    async mapMachine() {
      if (this.listmaquinas.length === 0) {
        this.$store.commit("SetLoading", true); // insere o loading

        // Ok
        const { data: machines } = await sap.get(`/machine`, {
          params: {
            unidade: "MAO",
          },
        });

        if (!machines.results) {
          this.$store.commit("SetLoading", false);
          this.listmaquinas = [];
          this.validationMachine = true;
          return;
        }
        this.listmaquinas = machines.results;
        this.$store.commit("SetLoading", false);
      }
    },
    clickTipoDeInj(tipoDeEntrada) {
      switch (tipoDeEntrada) {
        case 1:
          this.tipoDeInjecaoIndireta = true;
          this.tipoDeInjecaoCamQuent = false;
          break;

        case 2:
          this.tipoDeInjecaoIndireta = false;
          this.tipoDeInjecaoCamQuent = true;
          break;

        default:
          this.tipoDeInjecaoIndireta = false;
          this.tipoDeInjecaoCamQuent = false;
      }
    },

    addCavidadeAndProduto() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      const produto = this.lista_pro.find(
        (element) => element.cp === this.codigoProduto
      );

      const transformationArray = toRaw(this.$store.state.emitData.produtos);

      transformationArray.map((e) => {
        if (e.cp === this.codigoProduto) {
          this.cod_product = e.cp;
        }
      });

      const existeProduct = this.listaProdutos.find((e) => {
        return e.cp === this.codigoProduto;
      });

      if (existeProduct) {
        Toast.fire({
          icon: "error",
          title: "Código produto ja adicionado.",
          text: `Código produto ${this.codigoProduto} ja adicionado!`,
        });
        this.descproduto = "";
        this.codigoProduto = "";
        this.nCavidadeProduto = "";
        return;
      }

      // console.log(existeProduct.cp);

      let contTotal = this.contador + parseInt(this.nCavidadeProduto);
      const lista = {
        produto: produto,
        ncavidade: this.nCavidadeProduto,
      };
      if (isNaN(parseInt(this.numeroTotaldeCavid))) {
        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Nº Total de Cavidades Vazio!",
        });
        return;
      }
      if (isNaN(contTotal) && isNaN(parseInt(this.nCavidadeProduto))) {
        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Verifique se o campos estão preenchidos!",
        });
        return;
      }
      if (
        contTotal <= parseInt(this.numeroTotaldeCavid) &&
        parseInt(this.nCavidadeProduto) > 0
      ) {
        this.contador += parseInt(this.nCavidadeProduto);
        this.listaProdutos.push({
          cp: this.cod_product,
        });
        this.dados.lista_ProdutoAndCavidades.push(lista);
        this.BooleanTotalCavidade = true;
        this.descproduto = "";
        this.codigoProduto = "";
        this.nCavidadeProduto = "";
      } else {
        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Limite de Cavidade Excedida!",
        });
      }
    },

    excluir(index) {
      let ncavidade = this.dados.lista_ProdutoAndCavidades[index].ncavidade;

      this.contador -= ncavidade;
      this.dados.lista_ProdutoAndCavidades.splice(index, 1);
      this.listaProdutos.splice(index, 1);
      this.lista_pro.splice(index, 1);

      if (this.contador == 0) {
        this.BooleanTotalCavidade = false;
      }
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.MoldeAberto) {
        // Não Verificado
        const { data: moldeSapConsulta } = await sap.get(`/mold/`, {
          params: {
            unidade: "MAO",
            mold_code: this.$store.state.DataAllRRIM.InforGeral.MOLDE,
          },
        });

        this.numeroTotaldeCavid = moldeSapConsulta[0].cavidade;

        dataQuery.MoldeAberto[0].cavidade.map((element) => {
          this.dados.lista_ProdutoAndCavidades.push({
            produto: {
              cp: element.COD_PRODUTO,
              p: element.DESC_PRODUTO,
            },
            ncavidade: element.N_CAVIDADE,
          });

          // this.numeroTotaldeCavid = element.N_CAVIDADE;
        });

        this.dados.tipo_de_injecao.direta =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_DIR;
        this.dados.tipo_de_injecao.indireta =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_INDIR;
        this.dados.tipo_de_injecao.camera_quente =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_CAM;
        this.dados.tipo_de_injecao.bico_quente =
          dataQuery.MoldeAberto[0].TIPO_DE_INJ_BIC;
        this.dados.tipo_de_entrada_de_injecao =
          dataQuery.MoldeAberto[0].TIPO_DE_ENT_INJ;
        this.dados.gavetas.selectObject = dataQuery.MoldeAberto[0].GAVETAS;
        this.dados.gavetas.lado_movel =
          dataQuery.MoldeAberto[0].GAVETAS_L_MOVEL;
        this.dados.gavetas.lado_fixo = dataQuery.MoldeAberto[0].GAVETAS_L_FIXO;
        this.dados.gavetas.mecanico = dataQuery.MoldeAberto[0].GAVETAS_A_MEC;
        this.dados.gavetas.pneumatico = dataQuery.MoldeAberto[0].GAVETAS_A_PNE;
        this.dados.gavetas.hidraulico = dataQuery.MoldeAberto[0].GAVETAS_A_HID;

        this.dados.maquinas.op1 = dataQuery.MoldeAberto[0].MAQUINA_OP1;
        this.dados.maquinas.op2 = dataQuery.MoldeAberto[0].MAQUINA_OP2;
        this.dados.maquinas.op3 = dataQuery.MoldeAberto[0].MAQUINA_OP3;
        this.dados.observacao_tec = dataQuery.MoldeAberto[0].AVA_TEC;
      }
      if (dataQuery.InforGeral.homologacao[0].status !== 1) {
        this.showMoldePorCavidade = false;
      }
    },
  },

  watch: {
    numeroTotaldeCavid(newValue) {
      this.$emit("setCavity", newValue);
    },
    async Cavity(newValue) {
      this.numeroTotaldeCavid = newValue;
    },
    codigoProduto(newValue) {
      const produto = this.lista_pro.find((element) => element.cp === newValue);
      if (produto) {
        this.descproduto = produto.p;
        return;
      }
      this.descproduto = "";
    },

    dados: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$emit("dataMoldeAberto", this.dados);
      },
    },
  },
};
</script>

<style scoped>
input:disabled,
select:disabled,
textarea:disabled {
  background: #66666621;
}

.inputFlex {
  display: flex;
  align-items: center;
}

.button-add {
  display: flex;
  /* justify-content: end;
  */
  align-items: end;
}

.rounded-circle {
  border-radius: 50% !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem 0 rgba(58, 59, 69, 0.2) !important;
}

.tableCavidade .btnDelete button {
  width: 100%;
  background-color: var(--red);
  padding: 0.5rem 1rem;
  border: none;
  color: var(--white);
  border-radius: 0.5rem;
  font-weight: 700;
}

.tableCavidade {
  width: 100%;
  /* margin-top: 30px; */
  background: var(--white);
  padding: 0;
  /* overflow-x: scroll; */
}

.tableCavidade table {
  width: 100%;
  border-collapse: collapse;
}

.tableCavidade table thead {
  border-top: none;
  border-bottom: none;
  background: var(--green);
  color: var(--white);
}

.tableCavidade table thead td {
  font-weight: 550;
  border-top: none;
  border-bottom: 1.5px solid var(--gray);
  background: var(--green);
  color: var(--white);
}

.tableCavidade table tbody td {
  border-bottom: 1px solid var(--gray);
}

.tableCavidade table tr th {
  font-size: 0.8rem;
}

.tableCavidade table tr td {
  text-align: center;
  padding: 15px;
  font-size: 0.8rem;
}

.flex-1 {
  width: 100%;
  justify-content: center;
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.jbet {
  justify-content: space-between;
}

.m-10 {
  width: 6.5%;
}

.m-15 {
  width: 15%;
}

.m-20 {
  width: 20%;
}

.m-25 {
  width: 25%;
}

.m-40 {
  width: 40%;
}

.m-100 {
  width: 100%;
}

/* Input */

.input-group-text {
  display: flex;
  align-items: center;

  padding: 0.275rem 0.4rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  /* color: #212529; */
  text-align: center;
  white-space: nowrap;
  color: var(--white);
  background-color: var(--green);
  /* border: 1px solid #ced4da; */
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-right: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-left: none;
}

.flex-row {
  display: flex;
}

.flex-n {
  display: flex;
}

.flex {
  flex-direction: column;
}

.flex-direction-column {
  display: flex;
  flex-direction: column;
}

.align-items-center {
  align-items: center;
}

.flex-cq {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.gap {
  gap: 10px;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: 0.8rem;
  line-height: 1.5;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border-left: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-right: none;

  /* border-radius: 0.35rem; */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control-2 {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--gray_text);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  cursor: pointer;
}

.flex-row:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderGreen);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}

.flex-row:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderGreen);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}

.main-cq {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-row-2 {
  margin-top: 10px;
  display: flex;
  gap: 20px;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid var(--cinza);
  border-radius: 0.35rem;
}

.btn-success {
  color: var(--white);
  background-color: var(--green);
  border-color: var(--green);
  display: flex;
  align-items: center;
  justify-content: center;
}

.f-title {
  display: flex;
  align-items: center;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  min-height: 1.5rem;
  padding-left: 1rem;
  align-items: center;
  -webkit-print-color-adjust: exact;
}

.flex-column {
  margin-top: 10px;
  width: 100%;
  display: flex;
  /* align-items: center; */
  flex-direction: column;
  gap: 10px;
}

.justify-content-center {
  align-items: center;
  justify-content: center;
  display: flex;
}

.align-items-flex-start {
  align-items: flex-start;
  justify-content: center;
  display: flex;
}

/* .card-height{
height: 260px;
} */

.card-body-1 {
  border-radius: 10px;
  padding: 10px;
  border: 1px solid var(--cinza);
}

textarea.form-control-2 {
  height: auto;
}

.error {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background: var(--redTransparent);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.valid {
  border-color: var(--green);
  background: var(--white);
}

.valid:focus {
  outline-color: var(--green);
}

.fas .fa-plus {
  cursor: pointer;
}

@media (max-width: 768px) {
  .tableCavidade thead {
    display: none;
  }

  .tableCavidade table {
    border-radius: 10px 10px 0 0;
  }

  .tableCavidade td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
  }

  .tableCavidade td:nth-child(2) {
    background-color: var(--cinza);
  }

  .tableCavidade td:first-of-type {
    font-weight: bold;
    font-size: 1.2rem;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .tableCavidade td:not(:first-of-type):before {
    content: attr(data-title);
    display: block;
    font-weight: bold;
  }
}

@media (max-width: 425px) {

  .flex-1,
  .flex-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: inherit;
    gap: 20px;
  }

  .form-group {
    padding: 1rem;
  }

  .button-add {
    width: 40px;
  }

  .m-20,
  .m-40 {
    width: 100%;
  }
}
</style>
